import {
  Box,
  Button,
  Skeleton,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Image from 'src/components/image';
import Scrollbar from 'src/components/scrollbar';

export default function Preview({ postContent, handleShareOnLinkedin }) {
  // functions
  const formatContent = content => {
    content = content.replaceAll('\n', '<br />');

    const hashtags = content.match(/#[a-zA-Z0-9]+/g);
    if (hashtags) {
      hashtags.forEach(hashtag => {
        content = content.replaceAll(
          hashtag,
          `<span style="color: #0B66C2; font-weight: 600;">${hashtag}</span>`,
        );
      });
    }

    // identify links and make them blue
    const links = content.match(/(https?:\/\/[^\s]+)/g);
    if (links) {
      links.forEach(link => {
        content = content.replaceAll(
          link,
          `<a style="color: #0B66C2; font-weight: 600;">${link}</a>`,
        );
      });
    }

    return content;
  };

  return (
    <Stack
      px="16px"
      py="20px"
      width="50%"
      height="100%"
      borderRadius="6px"
      border={theme => `1px solid ${theme.palette.border.primaryBlack3}`}
    >
      <Stack spacing="8px" height="100%">
        <Stack spacing="12px">
          <Stack direction="row" alignItems="center" spacing="5.6px">
            <Image
              sx={{
                width: '28px',
              }}
              src="/assets/icons/brands/linkedin-avatar.svg"
              alt="linkedin-pfp"
            />
            <Stack spacing="2px">
              <Skeleton
                width={200}
                height={12}
                animation={false}
                sx={{
                  bgcolor: theme => theme.palette.background.primaryBlack2,
                }}
              />
              <Skeleton
                width={100}
                height={12}
                animation={false}
                sx={{
                  bgcolor: theme => theme.palette.background.primaryBlack3,
                }}
              />
            </Stack>
          </Stack>
          <Scrollbar
            sx={{
              maxHeight: '370px',
              width: '100%',
              overflowX: 'hidden',
            }}
          >
            <Typography
              fontSize={14}
              dangerouslySetInnerHTML={{
                __html: formatContent(postContent),
              }}
              sx={{
                p: '10px',
                '& p': {
                  margin: 0,
                },
              }}
            />
          </Scrollbar>
        </Stack>
        <Box
          sx={{
            flexGrow: 1,
          }}
        />
        <Button
          variant="contained"
          fullWidth
          endIcon={
            <SvgIcon>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5409 17.0412H14.5776V12.4004C14.5776 11.2937 14.5578 9.86911 13.0363 9.86911C11.4929 9.86911 11.2567 11.0749 11.2567 12.3198V17.0409H8.29344V7.49747H11.1382V8.80169H11.178C11.4627 8.3149 11.8741 7.91443 12.3684 7.64295C12.8627 7.37147 13.4214 7.23914 13.9849 7.26005C16.9884 7.26005 17.5422 9.23567 17.5422 11.8058L17.5409 17.0412ZM4.94969 6.19302C3.99992 6.19317 3.22984 5.42333 3.22969 4.47357C3.22953 3.5238 3.9993 2.75372 4.94906 2.75357C5.89883 2.75333 6.66891 3.52317 6.66906 4.47294C6.66915 4.92904 6.48805 5.36649 6.1656 5.68906C5.84316 6.01164 5.40578 6.19291 4.94969 6.19302ZM6.43141 17.0413H3.46492V7.49747H6.43133L6.43141 17.0413ZM19.0183 0.00145562H1.97586C1.17039 -0.00760688 0.509844 0.637627 0.5 1.4431V18.5566C0.509531 19.3625 1.17 20.0083 1.97578 19.9999H19.0183C19.8258 20.0099 20.4888 19.364 20.5 18.5566V1.44177C20.4885 0.634737 19.8254 -0.0104194 19.0183 0.000127492"
                  fill="#ffffff"
                />
              </svg>
            </SvgIcon>
          }
          onClick={handleShareOnLinkedin}
        >
          Post on Linkedin
        </Button>
      </Stack>
    </Stack>
  );
}

Preview.propTypes = {
  postContent: PropTypes.string.isRequired,
  handleShareOnLinkedin: PropTypes.func.isRequired,
};
